<template>
  <path
    d="M78.715 64.5207C88.6335 55.0641 96.7945 43.6223 98.2176 30.9365C98.7393 26.277 97.8947
     21.6946 97.0804 17.003C97.0087 16.5906 96.6148 16.3135 96.203 16.3865C95.7914 16.4579 95.5129 
     16.8515 95.5849 17.2624C96.3749 21.8116 97.2155 26.2527 96.709 30.7669C95.3084 43.2615 87.1479
      54.4792 77.3317 63.7449C77.229 63.6863 77.1266 63.6261 77.0243 63.5659C74.7742 62.242 71.1384 
      62.057 67.154 62.6699C61.3702 63.558 54.8378 66.0739 50.9697 68.7424C49.1847 69.9726 47.9579 
      71.2653 47.5176 72.4345C47.1497 73.4084 47.2491 74.3285 47.8938 75.1538C48.4269 75.8332 49.1847
       76.3135 50.129 76.6009C51.3895 76.984 53.0063 77.0239 54.8227 76.7869C61.5436 75.9101 71.0966 
       71.2709 74.446 68.3854C75.4955 67.4815 76.5329 66.5563 77.5566 65.6078C78.2074 65.97 78.8283 
       66.3184 79.3883 66.7049C80.2102 67.2723 80.8935 67.9174 81.2905 68.8536C82.0239 70.5809 
       81.8311 72.435 81.1819 74.2393C80.1441 77.1286 77.9457 79.8888 76.1357 81.886C65.9562 93.1197 
       51.5148 96.7599 37.6224 97.4781C23.5726 98.2054 10.0681 95.9391 1.95027 95.3521C1.5326 95.3228
        1.1678 95.6374 1.13824 96.0545C1.10671 96.4713 1.4216 96.835 1.83897 96.8658C10.0013 97.4555 
        23.577 99.7237 37.699 98.9935C51.9784 98.2542 66.7969 94.4504 77.2612 82.9033C79.1853 80.7776 
        81.5046 77.8256 82.6106 74.7512C83.3904 72.577 83.5707 70.3414 82.6879 68.2617C82.1731 67.0491
         81.3124 66.1896 80.2518 65.4571C79.7763 65.1287 79.2569 64.8246 78.715 64.5207ZM76.1707
          64.8251C74.1437 63.6822 70.9114 63.6263 67.3834 64.1689C61.8255 65.0222 55.5471 67.427 
          51.8293 69.9901C50.5842 70.8496 49.6329 71.7133 49.1421 72.5471C48.7864 73.1493 48.6989 
          73.7205 49.0889 74.2178C49.5374 74.7902 50.2429 75.1146 51.1093 75.2821C52.1074 75.4762 
          53.3088 75.4557 54.6292 75.2825C61.0748 74.4416 70.2449 70.0043 73.4556 67.2375C74.3689
          66.4498 75.2754 65.6449 76.1707 64.8251Z"          

    stroke-width="30"
    fill="none"
    fill-rule="evenodd"
    clip-rule="evenodd"
  />
</template>

<script>
export default {};
</script>

<style scoped>
path {
  font-family: var(--iconFontFamily);
  font-size: var(--iconFontSize);
  fill: var(--iconTextColor);
}
</style>
